import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { Toast } from 'primeng/toast';
import { NovatiqMessageService, DEFAULT_TOAST_LIFE_MS } from '../service/message.service';

@Component({
  templateUrl: './authorization.layout.html',
  styleUrls: ['./authorization.layout.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, TranslateModule, Toast]
})
export class AuthorizationLayoutComponent implements OnInit {
  readonly currentYear = new Date().getFullYear();

  private readonly novatiqMessageService = inject(NovatiqMessageService);
  private readonly messageService = inject(MessageService);
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.novatiqMessageService
      .getMessage()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((message) => {
        if (message) {
          this.messageService.clear();
          this.messageService.add({
            severity: message.severity,
            detail: message.text,
            life: message.life ?? DEFAULT_TOAST_LIFE_MS,
            key: message.key
          });
        } else {
          this.messageService.clear();
        }
      });
  }

  privacyPolicy(): void {
    window.open('https://novatiq.com/privacy-policy/', '_blank');
  }

  termsAndConditions(): void {
    window.open('https://novatiq.com/terms-conditions/', '_blank');
  }
}
